import { render, staticRenderFns } from "./FilterCategoryBase.vue?vue&type=template&id=3e2e7a01&scoped=true&"
import script from "./FilterCategoryBase.vue?vue&type=script&lang=js&"
export * from "./FilterCategoryBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2e7a01",
  null
  
)

export default component.exports